import React from 'react';

const Login = React.lazy(() => import('./login.page'));

export default Login;